import { useSitecoreContext } from './useSitecoreContext';

/** If currently rendering in Sitecore's Experience Editor. */
export function useIsEditing() {
	const { sitecoreContext } = useSitecoreContext();
	return sitecoreContext?.pageEditing || false;
}
